import { render } from "./Skeleton.vue?vue&type=template&id=fb9f2670&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=fb9f2670&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9f2670"],['__file',"src/common/Skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb9f2670"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb9f2670', __exports__)) {
    api.reload('fb9f2670', __exports__)
  }
  
  module.hot.accept("./Skeleton.vue?vue&type=template&id=fb9f2670&scoped=true", () => {
    api.rerender('fb9f2670', render)
  })

}


export default __exports__